import React from "react";

const YoutubePage = () => {
  return (
    <>
      <div className="salva-youtube-video">
        <iframe
          width="1280"
          height="720"
          src="https://www.youtube.com/embed/s4xnyr2mCuI"
          title="H&M Conscious: Sustainable fashion through recycled clothes"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
    </>
  );
};
export default YoutubePage;
